import { useMetadadosItem } from './useMetadadosItem';

export const useMetadadosAutor = () => {
  const criterios = [{ texto: 'Este campo não pode estar vazio', otimizado: false }];

  function validacoes(index, autor) {
    switch (index) {
      case 0:
        return autor !== null && autor !== undefined && autor.length > 0;
    }
  }

  return useMetadadosItem({ itemCriterios: criterios, validacoesFn: validacoes });
};
